<template>
  <div class="main_right">
    <div class="Box">
      <div class="aRow">
        <el-date-picker v-model="time_select" value-format="yyyy-MM-dd" type="date"
                        placeholder="选择日期" @change="timeChange()">
        </el-date-picker>
      </div>
      <div class="testpage" style="height:calc(100% - 3vw);">
        <el-table stripe height="calc(100% - 50px)" class="table" :data="tableData" border
                  :header-cell-style="{background:'#F1F8FF',color:'#333','text-align':'center'}">
          <el-table-column width="100" label="序号" :index="indexMethod" type="index" align="center">
          </el-table-column>
          <el-table-column property="xsxm" label="姓名" align="center">

          </el-table-column>
          <el-table-column property="bjmc" label="常规班" align="center"></el-table-column>

          <el-table-column property="xb" label="性别" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.xb==1"><i class="el-icon-male" style="color:#67C23A;font-size:18px"></i> 男</div>
              <div v-else-if="scope.row.xb==2"><i class="el-icon-female" style="color:#F56C6C;font-size:18px"></i> 女
              </div>
              <div v-else>未知</div>
            </template>
          </el-table-column>
          <!-- curClassChl 当前课次所有词汇 -->
          <el-table-column property="curClassYzwchl" label="当天所有课次词汇量" align="center">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import {screenAllStudentRankingApi} from '@/api/teacher.js'

export default {
  name: 'finishStat',
  data() {
    return {
      search_data: {
        yhid: this.$store.state.userInfo.yhid,
        zhid: this.$store.state.userInfo.zhid,
        bjid: JSON.parse(sessionStorage.getItem('jxInfo')).bjid,
      },
      pages: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      tableData: [],
      stuRankData: [],
      time_select: new Date().toISOString().slice(0, 10), // 默认当前日期
      time_section: [],
      timeFirst: null,
    }
  },

  mounted() {
    this.getAllStudentRank()
    this.setTimer()
  },

  methods: {
    timeChange() {
      this.search_data.qryDate = this.time_select; // 同步 qryDate 与选择的日期
      this.handelSearch(); // 调用搜索或刷新方法
    },

    getAllStudentRank() {
      const data = this.search_data;
      data.currentPage = this.pages.currentPage;
      data.pageSize = this.pages.pageSize;
      data.qryDate = this.time_select;
      screenAllStudentRankingApi(data).then(res => {
        if (res.result) {
          console.log(res.result)
          this.pages.total = res.result.total
          this.tableData = res.result.list;
          if (this.pages.currentPage == 1) {
            this.stuRankData = this.tableData
          }
        }
      })
    },
    indexMethod(index) {
      return (this.pages.currentPage - 1) * this.pages.pageSize + index + 1;
    },
    handleCurrentChange(val) {
      this.pages.currentPage = val;
      this.getAllStudentRank()
    },
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.handelSearch()
    },
    handelSearch() {
      this.pages.currentPage = 1;
      this.getAllStudentRank()
    },
    formatPercentage(num, all) {
      if (all && num) {
        const percentage = (Number(num) / Number(all)).toFixed(2)
        return percentage
      }
      return 0
    },
    customColorMethod(percentage) {
      if (percentage < 50) {
        return '#E86452';
      } else if (percentage < 60) {
        return '#E6A23C';
      } else if (percentage < 70) {
        return '#5B8FF9';
      } else if (percentage < 80) {
        return '#6f7ad3';
      } else if (percentage < 90) {
        return '#5AD8A6';
      } else if (percentage > 90) {
        return '#67C23A';
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.main_right {
  width: calc(100% - 10.5vw);
  height: 100%;
  float: left;
  box-sizing: border-box;
  padding: 0 2%;
  position: relative;

  .Box {
    width: 100%;
    height: 100%;
    box-shadow: 0px 0px 16px 0px rgba(89, 144, 255, 0.3);
    border-radius: 10px;
    padding: 2%;
    box-sizing: border-box;
    position: relative;
  }

  .vocabulary {
    width: 30%;
    height: 3vw;
    float: left;

    div {
      width: 14vw;
      height: 3vw;
      background: #f1f8ff;
      border-radius: 10px;
      line-height: 3vw;
      box-sizing: border-box;
      padding: 0 3%;
      color: #333;

      span {
        display: block;
      }

      span:nth-child(1) {
        // display: block;
        font-size: 1.1vw;
        float: left;
      }

      p {
        float: right;

        span:nth-child(1) {
          font-size: 1.5vw;
          color: #409eff;
          font-weight: 600;
          float: left;
          margin-right: 1.5vw;
        }

        span:nth-child(2) {
          font-size: 1vw;
          float: left;
        }
      }
    }
  }

  .pagination {
    position: absolute;
    bottom: 1vw;
    right: 3vw;
    z-index: 1;
  }

  .testpage {
    width: 100%;
    position: relative;

    p:nth-child(1) {
      width: 100%;
      height: 2.5vw;
      text-align: center;
      position: relative;
      color: #333;
      font-size: 1.5vw;
      line-height: 2.5vw;
    }
  }

  .table {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 2vw;
    top: 2vw;
  }

  .aRow {
    width: 100%;
  }

  .aRow:after {
    /*伪元素是行内元素 正常浏览器清除浮动方法*/
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }

  .exchange {
    width: 7vw;
    float: right;
    height: 2.5vw;
    background: #5990ff;
    box-shadow: 0px 0px 16px 0px rgba(89, 144, 255, 0.3);
    border-radius: 30px;
    margin-top: 0.25vw;
    color: #fff;
    font-size: 1vw;
    position: relative;
    cursor: pointer;

    span {
      display: block;
      position: absolute;
      top: 50%;
      width: 100%;
      text-align: center;
      transform: translateY(-50%);
    }
  }

  .tips {
    position: absolute;
    bottom: 1%;
    left: 4%;
    width: 100%;

    p:nth-child(1) {
      font-size: 1vw;
      color: #333;
      width: 100%;
    }

    p:nth-child(2) {
      margin-top: 0.3vw;
      font-size: 0.8vw;
      color: #666;
      width: 100%;

      span:last-child {
        margin-left: 10%;
      }
    }
  }
}
/* ========== 手机端适配样式 ========== */
@media screen and (max-width: 768px) {
  .main_right {
    width: calc(100% - 80px);
    padding: 0 10px;
    height: 100%;
    overflow: hidden;

    .Box {
      padding: 12px 10px;
      display: flex;
      flex-direction: column;
      height: 100%;
      box-sizing: border-box;
      ::v-deep  .el-input .el-input__inner {
        height: 5vh !important;
        font-size: 12px;
      }

      ::v-deep  .el-input .el-input__icon {
        width: 30px !important;
        padding-top: 3px;
      }

      .aRow {
        flex-shrink: 0;
        margin-bottom: 15px;

        .el-date-picker {
          width: 100% !important;

          ::v-deep  .el-input__inner {
            height: 40px;
            line-height: 40px;
            font-size: 13px;
          }
        }
      }
    }

    .testpage {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
      width: 100%;
      overflow: hidden;

      .table {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        ::v-deep  .el-table__header-wrapper {
          flex-shrink: 0;
        }

        ::v-deep  .el-table__body-wrapper {
          flex: 1;
          overflow: auto !important;
        }

        ::v-deep  .el-table__header {
          width: 100%;
          min-width: 500px;
        }

        ::v-deep  .el-table__body {
          width: 100%;
          min-width: 500px;
        }

        ::v-deep  .el-table__fixed {
          display: none !important;
        }

        ::v-deep  .el-table__fixed-right {
          display: none !important;
        }
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .main_right {
    width: calc(100% - 65px);
    padding: 0 8px;

    .Box {
      padding: 10px 8px;

      .aRow .el-date-picker ::v-deep  .el-input__inner {
        height: 36px;
        font-size: 12px;
      }

      ::v-deep  .el-input .el-input__inner {
        height: 5vh !important;
        font-size: 12px;
      }

      ::v-deep  .el-input .el-input__icon {
        width: 30px !important;
        padding-top: 3px;
      }

    }
  }
}
</style>
<style lang="scss" scoped>
.el-table::before {
  display: none;
}
</style>
